const data = [
  {
    title: "ЦВЕТОК театру теней эмиля мэя",
    url: "",
    year: "1963",
  },
  {
    title: "МУЗЫКА К ПОСТАНОВКАМ МОСКОВСКОГО ТЕАТРА ТЕНЕЙ",
    url: "",
    year: "1964",
  },
  {
    title: "стриптиз-кабак РАЗОРУЖЕНИЕ",
    url: "",
    year: "1966",
  },
  {
    title: "CENTERVILLE 10 действий оперы",
    url: "https://youtu.be/2LG6Fv7clEk",
    year: "1966",
  },
  {
    title: "WHEN A GOLDEN GIRL…",
    url: "",
    year: "1966",
  },
  {
    title: "ГАМЛЕТ",
    url: "",
    year: "1967",
  },
  {
    title: "LAMENTO",
    url: "https://www.youtube.com/watch?v=b4rM-ENfcVY",
    year: "1967",
  },
  {
    title: "SALVE!",
    url: "https://youtu.be/NWjA--3yBlM",
    year: "1967",
  },
  {
    title: "TERTIUM NON DATUR",
    url: "",
    year: "1967",
  },
  {
    title: "ПЕТРОГРАДСКИЕ ВОРОБЬИ оркестра двенадцати",
    url: "https://youtu.be/gTr15Z6B3HU",
    year: "1967",
  },
  {
    title: "MONODIA",
    url: "https://www.youtube.com/watch?v=oVMenqNUa3M&list=PLcnxwMUzj9W-_DWq8BiE84TIrSOSD0RXO",
    year: "1968",
  },
  {
    title: "choreuō MEDEA",
    url: "https://youtu.be/JwncIY-Mwfo",
    year: "1968",
  },
  {
    title:
      "музыкальная заставка к постоянным телепередачам МУЗЫКАЛЬНЫЙ ТЕЛЕЗАЛ для голоса с челестой",
    url: "",
    year: "1972",
  },
  {
    title:
      "музыкальная заставка к постоянным телепередачам В СВОБОДНЫЙ ЧАС для детского хора с сопровождением",
    url: "",
    year: "1972",
  },
  {
    title: "ЖИДКИЕ КРИСТАЛЛЫ (научно-популярный)",
    url: "https://tst1.net-film.ru/film-60448/",
    year: "1973",
  },
  {
    title: "ЛЕД И ПЛАМЕНЬ (научно-популярный)",
    url: "",
    year: "1974",
  },
  {
    title: "НА ПЕРЕКРЕСТКЕ МНЕНИЙ (научно-популярный)",
    url: "",
    year: "1974",
  },
  {
    title: "ВРЕМЯ НЕ ЖДЕТ (научно-популярный)",
    url: "",
    year: "1975",
  },
  {
    title: "ДВАЖДЫ ДВА",
    url: "",
    year: "1975",
  },
  {
    title: "НАСТАНЕТ ДЕНЬ (научно-популярный)",
    url: "",
    year: "1975",
  },
  {
    title: "ЖИЗНЬ В МАГНИТНОМ ПОЛЕ (научно-популярный)",
    url: "",
    year: "1975",
  },
  {
    title: "ЛУЧ (научно-популярный)",
    url: "",
    year: "1975",
  },
  {
    title: "ПАРАД ИЗОБРЕТЕНИЙ (научно-популярный)",
    url: "",
    year: "1976",
  },
  {
    title: "ПОЛЯРНЫЙ ЭКСПЕРИМЕНТ (научно-популярный)",
    url: "",
    year: "1976",
  },
  {
    title: "ИДЕЯ АКАДЕМИКА ЦЕЛИКОВА (научно-популярный)",
    url: "",
    year: "1977",
  },
  {
    title: "СЛЕД РОСОМАХИ",
    url: "https://www.youtube.com/watch?v=RvXpyVLzUTU",
    year: "1978",
  },
  {
    title: "ШТРИХИ К ПОРТРЕТУ ГОРОДА (научно-популярный)",
    url: "",
    year: "1978",
  },
  {
    title: "РАННИЕ ЖУРАВЛИ",
    url: "https://www.youtube.com/watch?v=x85KNpKIzqM",
    year: "1979",
  },
  {
    title: "РАФФЕРТИ (телефильм)",
    url: "https://www.youtube.com/watch?v=moVzVl32YX8",
    year: "1980",
  },
  {
    title: "Я – АКТРИСА",
    url: "https://www.youtube.com/watch?v=-N1Mj_iCWS0",
    year: "1980",
  },
  {
    title: "ВРЕМЯ МЫСЛИТЬ ЭКОЛОГИЧЕСКИ (научно-популярный)",
    url: "",
    year: "1980",
  },
  {
    title: "ТРЕБУЮТСЯ МУЖЧИНЫ",
    url: "https://www.youtube.com/watch?v=c3KhgseP1Mc",
    year: "1983",
  },
  {
    title: "ТОРПЕДОНОСЦЫ",
    url: "https://www.youtube.com/watch?v=W1Fuu8kklcc",
    year: "1983",
  },
  {
    title: "ПРОТИВОСТОЯНИЕ (телефильм)",
    url: "https://www.youtube.com/watch?v=K0obO8vE8U0",
    year: "1985",
  },
  {
    title: "РАССКАЗ ОБ ЭКСПЕРИМЕНТЕ (научно-популярный)",
    url: "",
    year: "1985",
  },
  {
    title: "О ТОМ, ЧЕГО НЕ БЫЛО (ЗВЕЗДА В ТУМАНЕ)",
    url: "",
    year: "1986",
  },
  {
    title: "МИФ (телефильм)",
    url: "https://vk.com/video-37492055_456245295?to=L3ZpZGVvLTM3NDkyMDU1XzQ1NjI0NTI5NT8-",
    year: "1986",
  },
  {
    title: "ПЕТРОГРАДСКИЕ ГАВРОШИ",
    url: "",
    year: "1987",
  },
  {
    title: "БОЛЬШАЯ ИГРА",
    url: "https://www.youtube.com/watch?v=w40hpmbaOLc&pp=ygUhI9Cx0L7Qu9GM0YjQsNGP0LjQs9GA0LDRhNC40LvRjNC8",
    year: "1988",
  },
  {
    title: "КРИМИНАЛЬНЫЙ ТАЛАНТ (телефильм)",
    url: "https://www.youtube.com/watch?v=f1B2e3Pq5Jo",
    year: "1988",
  },
  {
    title: "ЧП РАЙОННОГО МАСШТАБА",
    url: "https://vk.com/video-37492055_456252176",
    year: "1988",
  },
  {
    title: "ЭТО БЫЛО У МОРЯ (ИНТЕРНЫ)",
    url: "https://vk.com/video-37492055_456245887",
    year: "1989",
  },
  {
    title: "ЛИЧНОЕ ДЕЛО АННЫ АХМАТОВОЙ",
    url: "https://www.youtube.com/watch?v=MlqvYIiWDQE",
    year: "1989",
  },
  {
    title:
      "Я СЛУЖИЛ В ОХРАНЕ СТАЛИНА, ИЛИ ОПЫТ ДОКУМЕНТАЛЬНОЙ МИФОЛОГИИ (документальный)",
    url: "https://www.youtube.com/watch?v=GN6N-h7B9G4",
    year: "1989",
  },
  {
    title: "БОЛЬШОЙ КОНЦЕРТ НАРОДОВ. ИЛИ ДЫХАНИЕ ЧЕЙН-СТОКСА (мини-сериал)",
    url: "https://www.youtube.com/watch?v=UiySlD1IYmE",
    year: "1991",
  },
  {
    title: "НЕВОЗВРАЩЕНЕЦ",
    url: "https://www.youtube.com/watch?v=biTerj7buSw",
    year: "1991",
  },
  {
    title: "ЛЮБОВЬ – СМЕРТЕЛЬНАЯ ИГРА…",
    url: "https://m.youtube.com/watch?v=bYERKPo_m-E&t=1281s",
    year: "1991",
  },
  {
    title: "В ТУМАНЕ",
    url: "",
    year: "1992",
  },
  {
    title: "ОСТРОВА (документальный)",
    url: "",
    year: "1993",
  },
  {
    title: "ИГРА В БРАСЛЕТАХ",
    url: "https://www.youtube.com/watch?v=y65CYNdOy1o",
    year: "1998",
  },
  {
    title: "ЦВЕТЫ КАЛЕНДУЛЫ",
    url: "https://vk.com/video-165903_456250109",
    year: "1998",
  },
  {
    title: "ПРИШЕЛЬЦАМ НОВЫМ (биография, документальный)",
    url: "",
    year: "1999",
  },
  {
    title: "ЖЕНСКАЯ ЛОГИКА-2",
    url: "https://vk.com/video17961062_456239489",
    year: "2002",
  },
  {
    title: "ПРИЗНАНИЕ стихотворением фортепьяно",
    url: "",
    year: "2003",
  },
  {
    title: "РОЖДЕНИЕ",
    url: "",
    year: "2003",
  },
  {
    title: "ИТАЛЬЯНЕЦ",
    url: "https://vk.com/video-216155816_456240016",
    year: "2005",
  },
  {
    title: "МАСКАРАД (фильм-спектакль)",
    url: "",
    year: "2006",
  },
  {
    title: "PIENO DOLCISSIMO",
    url: "https://youtu.be/_ZJgWQB330k?si=Mv-yBD58hCUYw_3n",
    year: "2007",
  },
  {
    title: "ДЯДЮШКИН СОН (фильм-спектакль)",
    url: "https://vk.com/video-161138645_456241389",
    year: "2011",
  },
  {
    title: "БЫЛО ЛЕТО",
    url: "",
    year: "2014",
  },
  {
    title: "HARM (документальный)",
    url: "",
    year: "2015",
  },
  {
    title: "UNSUBTITLED (документальный)",
    url: "",
    year: "2015",
  },
  {
    title: "FILM",
    url: "",
    year: "2016",
  },
  {
    title:
      "АЛИСА В СТРАНЕ ЧУДЕС 24 картинки льюиса кэрролла в театре играющих, поющих, танцующих (1994-2020)",
    url: "https://youtu.be/nKilJ6xhdHU",
    year: "2020",
  },
  {
    title: "СОВЕТ ПРЕВЕЧНЫЙ",
    url: "",
    year: "2020",
  },
  {
    title: "ЗАЧЕМ СНЯТСЯ СНЫ|WHY DREAMS",
    url: "",
    year: "2021",
  },
  {
    title:
      "ОБЖАЛОВАНИЮ НЕ ПОДЛЕЖИТ. ГАРМОНИСТ (короткометражный, документальный)",
    url: "https://vk.com/video-117035020_456240293",
    year: "2021",
  },
];

export default data;
